import Grid from "@material-ui/core/Grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import BranchListComponent from "./branch.list.component";
import BranchBasicDetailsComponent from "./branch.basic.details.component";
import BasicDetails from "./branch.details.component";


function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  
export default function Branch() {
    const history = useHistory();
    const query = useQuery();
  
    return (
        <div>
           {query.get("mode") === "create" ? (
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginBottom: "20px",
              height: "2em",
              color: "inherit",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
           
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Branch Management- Create Branch
              </span>
            
          </Grid>
          ) : null}
    
          {(() => {
            switch (query.get("mode")) {
              case "viewList":
                return <BranchListComponent />;
              case "create":
                return <BasicDetails />;
              default:
                history.push("/branch?mode=viewList");
            }
          })()}
        </div>
      );
}